import _Vue from 'vue'
import store from '@/store'
import { Getters } from '@/store/getters'
import ability from '@/plugins/ability'

function resolveTeamIds(input: number | number[] | null | undefined): { ids: number[]; explicit: boolean } {
  if (Array.isArray(input)) return { ids: input.filter(id => id != null), explicit: true }
  if (input !== undefined && input !== null) return { ids: [input], explicit: true }

  const currentTeam: any = store.getters[Getters.APP_CURRENT_TEAM]
  if (!currentTeam || currentTeam === 'all') return { ids: [], explicit: false }
  return { ids: currentTeam.id != null ? [currentTeam.id] : [], explicit: false }
}

function hasKey(obj: any, key: string): boolean {
  return obj != null && Object.prototype.hasOwnProperty.call(obj, key)
}

export default {
  install(Vue: typeof _Vue) {
    Vue.mixin({
      methods: {
        $can(abilityKey: string, teamId?: number | number[] | null): boolean {
          const { ids: teamIds, explicit } = resolveTeamIds(teamId)
          const tag = `(teamIds=[${teamIds.join(',')}], ${explicit ? 'explicit' : 'from-store'})`

          const user: any = store.getters[Getters.AUTH_USER]

          if (user && user.coach) {
            const coachTypes = user.coach_types || []
            const globalCoachType = user.coach.coach_type
            const globalPerms = globalCoachType && globalCoachType.permissions

            const resolveForTeam = (tid: number): boolean => {
              const team = (user.coach.teams || []).find((t: any) => t.id === tid)
              if (team && team.coach_type_id) {
                const teamType = coachTypes.find((ct: any) => ct.id === team.coach_type_id)
                if (teamType && hasKey(teamType.permissions, abilityKey)) {
                  const allowed = teamType.permissions[abilityKey] === true
                  // eslint-disable-next-line no-console
                  console.log(`[$can] ${abilityKey} → ${allowed ? 'ALLOW' : 'DENY'} via team-coach-type:${teamType.name}#${teamType.id} (team=${tid}) ${tag}`)
                  return allowed
                }
              }
              if (globalPerms && hasKey(globalPerms, abilityKey)) {
                const allowed = globalPerms[abilityKey] === true
                // eslint-disable-next-line no-console
                console.log(`[$can] ${abilityKey} → ${allowed ? 'ALLOW' : 'DENY'} via global-coach-type:${globalCoachType.name}#${globalCoachType.id} (team=${tid}) ${tag}`)
                return allowed
              }
              const allowed = ability.can(abilityKey, null)
              // eslint-disable-next-line no-console
              console.log(`[$can] ${abilityKey} → ${allowed ? 'ALLOW' : 'DENY'} via CASL/Bouncer (team=${tid}) ${tag}`)
              return allowed
            }

            if (teamIds.length === 0) {
              if (globalPerms && hasKey(globalPerms, abilityKey)) {
                const allowed = globalPerms[abilityKey] === true
                // eslint-disable-next-line no-console
                console.log(`[$can] ${abilityKey} → ${allowed ? 'ALLOW' : 'DENY'} via global-coach-type:${globalCoachType.name}#${globalCoachType.id} ${tag}`)
                return allowed
              }
              const allowed = ability.can(abilityKey, null)
              // eslint-disable-next-line no-console
              console.log(`[$can] ${abilityKey} → ${allowed ? 'ALLOW' : 'DENY'} via CASL/Bouncer (no-team-scope) ${tag}`)
              return allowed
            }

            return teamIds.some(resolveForTeam)
          }

          const allowed = ability.can(abilityKey, null)
          // eslint-disable-next-line no-console
          console.log(`[$can] ${abilityKey} → ${allowed ? 'ALLOW' : 'DENY'} via CASL/Bouncer (no-coach) ${tag}`)
          return allowed
        }
      }
    })
  }
}
